define('home/views/MotdAlertView',[
    'backbone-marionette',

    'core/utils/storage',
    'remote/config',

    'home/templates/motdAlert',
], function (
    Marionette,

    storage,
    remoteConfig,

    motdAlertTemplate
) {
    'use strict';

    var MOTD_KEY = 'motd';
    var lounge = remoteConfig.lounge || {};
    var motdTitle = lounge.motd_home_title;
    var motdUrl = lounge.motd_home_url;
    var motdObj = storage.get(MOTD_KEY) || {};

    var MotdAlertView = Marionette.ItemView.extend({
        template: motdAlertTemplate,
        className: 'motd-alert__wrapper',

        templateHelpers: function () {
            var dismissed = motdObj[motdUrl];

            return {
                motdTitle: motdTitle,
                motdLink: motdUrl,
                hideAlert: dismissed && !this.persistent ? dismissed : false,
                persistentAlert: this.persistent,
            };
        },

        events: {
            'click [data-action=close-alert]': 'closeAlert',
        },

        initialize: function (options) {
            this.persistent = options && options.persistent;
        },

        closeAlert: function () {
            motdObj[motdUrl] = true;
            storage.set(MOTD_KEY, motdObj);
            this.$el.remove();
        },
    });

    return MotdAlertView;
});

